import { Markdown } from '@components/shared/Markdown'
import { CategoryPurpose } from '@type/buzzkuri/programs-categor'
import React from 'react'

type Props = {
  categoryPurpose: CategoryPurpose
}

export const CategoryObjectivesContent = ({
  categoryPurpose,
}: Props): JSX.Element => (
  <div className="p-[6.1vw] lg:pt-[2.9vw] lg:pr-[3.6vw] lg:pb-[3.4vw] lg:pl-[1.8vw] bg-[#F7F6F5]">
    <Markdown content={categoryPurpose.description} />
  </div>
)
